/**
 * 认证服务 - 管理用户认证相关功能
 */

// 认证服务对象
export const authService = {
  /**
   * 保存 token 到 localStorage
   * @param token JWT token
   */
  saveToken(token: string): void {
    if (typeof window !== 'undefined') {
      localStorage.setItem('auth_token', token);
    }
  },

  /**
   * 从 localStorage 获取 token
   * @returns token 或 null
   */
  getToken(): string | null {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('auth_token');
    }
    return null;
  },

  /**
   * 清除 localStorage 中的 token
   */
  clearToken(): void {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('auth_token');
    }
  },

  /**
   * 检查用户是否已认证
   * @returns 是否已认证
   */
  isAuthenticated(): boolean {
    return !!this.getToken();
  },

  /**
   * 获取认证头信息
   * @returns 包含 token 的认证头对象
   */
  getAuthHeaders(): Record<string, string> | null {
    const token = this.getToken();
    if (token) {
      return { 'Authorization': `Bearer ${token}` };
    }
    return null;
  }
};

// 默认导出
export default authService; 